import { render, staticRenderFns } from "./GeneralSettingsCheckoutRequestingDeliveryAllowed.vue?vue&type=template&id=7db3ec0a&"
import script from "./GeneralSettingsCheckoutRequestingDeliveryAllowed.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsCheckoutRequestingDeliveryAllowed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports